<script>
export default {
  name: 'More',
  props: {
    size: {
      type: [Number, String],
      default: 24,
    },
    color: {
      type: String,
      default: '#8E8E8E',
    },
  },
}
</script>

<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.09922 6.3H7.69922V4.9C7.69922 4.515 7.38422 4.2 6.99922 4.2C6.61422 4.2 6.29922 4.515 6.29922 4.9V6.3H4.89922C4.51422 6.3 4.19922 6.615 4.19922 7C4.19922 7.385 4.51422 7.7 4.89922 7.7H6.29922V9.1C6.29922 9.485 6.61422 9.8 6.99922 9.8C7.38422 9.8 7.69922 9.485 7.69922 9.1V7.7H9.09922C9.48422 7.7 9.79922 7.385 9.79922 7C9.79922 6.615 9.48422 6.3 9.09922 6.3ZM7.00039 12.6C3.91269 12.6 1.40039 10.0877 1.40039 6.99998C1.40039 3.91228 3.91269 1.39998 7.00039 1.39998C10.0881 1.39998 12.6004 3.91228 12.6004 6.99998C12.6004 10.0877 10.0881 12.6 7.00039 12.6ZM7 0C3.1402 0 0 3.1402 0 7C0 10.8598 3.1402 14 7 14C10.8598 14 14 10.8598 14 7C14 3.1402 10.8598 0 7 0Z"
      :fill="color"
    />
  </svg>
</template>
